const en = {
    chooseListingTypePopup: {
      popupTitle: 'What ad would you like to add?',
      goodsBtn: 'Goods',
      servicesBtn: 'Services',
      realEstateBtn: 'Real Estate',
      changesSaved: "Changes received, you'll see them on the site soon",
      somethingWrong: "Something went wrong, please try again",
    },
    messagesPopup: {
      maxAdsPopupMessage: 'You can add up to 20 listings, you have added',
      changesSaved: "Changes received, you'll see them on the site soon",
      somethingWrong: "Something went wrong, please try again",
    },
    areYouSurePopup: {
      popupTitle: 'Choose a reason why you want to delete the ad:',
      deleteBtn: 'Delete',
      cancelBtn: 'Cancel',
      reasons: [
        'Sold on «GOODS»',
        'Sold somewhere else',
        'Changed my mind about selling',
        'Other reason'
      ],
    },
  }
  
  const rus = {
    chooseListingTypePopup: {
      popupTitle: 'Какое объявление вы хотите добавить?',
      goodsBtn: 'Товары',
      servicesBtn: 'Услуги',
      realEstateBtn: 'Недвижимость',
    },
    messagesPopup: {
      maxAdsPopupMessage: 'Можно добавлять не более 20 объявлений, у вас добавлено',
      changesSaved: "Изменения получены, скоро вы сможете их увидеть на сайте",
      somethingWrong: "Что-то пошло не так, попробуйте ещё раз",
    },
    areYouSurePopup: {
      popupTitle: 'Выберите причину, по которой вы удаляете объявление:',
      deleteBtn: 'Удалить',
      cancelBtn: 'Отмена',
      reasons: [
        'Продал на «ГУДС»',
        'Продал где-то еще',
        'Передумал продавать',
        'Другая причина'
      ],
    },
  }
  
  const hebrew = {
    chooseListingTypePopup: {
      popupTitle: 'איזה מודעה תרצה להוסיף?',
      goodsBtn: 'מוצרים',
      servicesBtn: 'שירותים',
      realEstateBtn: 'נדל״ן',
    },
    messagesPopup: {
      maxAdsPopupMessage: 'ניתן להוסיף עד 20 מודעות, כבר הוספת',
      changesSaved: "השינויים נשמרו, תראו אותם באתר בקרוב",
      somethingWrong: "משהו השתבש, נסה שוב",
    },
    areYouSurePopup: {
      popupTitle: 'בחר סיבה למחיקת המודעה:',
      deleteBtn: 'מחק',
      cancelBtn: 'ביטול',
      reasons: [
        'נמכר ב-“GOODS”',
        'נמכר במקום אחר',
        'שיניתי את דעתי לגבי המכירה',
        'סיבה אחרת'
      ],
    },
  }
  
  const choose = { en, rus, hebrew };
  
  export default choose;
  